import { render, staticRenderFns } from "./OrdersSheet.vue?vue&type=template&id=f71c6b5e&scoped=true"
import script from "./OrdersSheet.vue?vue&type=script&lang=js"
export * from "./OrdersSheet.vue?vue&type=script&lang=js"
import style0 from "./OrdersSheet.vue?vue&type=style&index=0&id=f71c6b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71c6b5e",
  null
  
)

export default component.exports